<script>
import moment from 'moment';

export default {
  name: 'SlotsTable',
  props: ['data', 'getDateAndMonth', 'getTime'],
  methods: {
    convertSlotDateToTime(slot) {
      const fullDateMoment = moment.utc(`${slot.start_date}T${slot.start_time}`);
      const fullDateUTC = fullDateMoment.utc().format();
      return this.getTime(fullDateUTC);
    },
    getDateAndMonth(date) {
      return moment.utc(date).format('DD. MMMM YYYY');
    },
  }
}
</script>

<template>
  <div class="invoice-rd">
    <table>
      <colgroup>
        <col style="width: auto;">
        <col class="invoice-rd__col-group">
        <col class="invoice-rd__col-group">
      </colgroup>
      <thead>
        <tr>
          <th class="text-14 fw-700 text-left">{{'Treatment' | translate}}</th>
          <th class="invoice-rd__content text-14 fw-700">{{'Booking Date' | translate}}</th>
          <th class="invoice-rd__content text-14 fw-700">{{'Price' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="slot in data">
          <td>
            <p class="text-14 fw-500 color-default">{{slot.treatment}}</p>
            <p class="text-12 fw-300">{{'Duration' | translate}}: {{slot.duration}} min</p>
          </td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">
              {{getDateAndMonth(slot.start_date)}}
            </p>
            <p class="invoice-rd__content text-12 fw-300">{{'Time' | translate}} - {{convertSlotDateToTime(slot)}}</p>
          </td>
          <td>
            <p v-if="parseFloat(slot.price, 0).toFixed(2) !== '0.00'" class="invoice-rd__content text-14 fw-500 color-default">
              {{ parseFloat(slot.price, 0).toFixed(2) }} CHF
            </p>
            <p v-else class="invoice-rd__content text-14 fw-500 color-default">-</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="less" scoped>
@import "../../less/redesign/vars";
.text-left {
  text-align: left;
}
.invoice-rd {
  border: 1px solid @grey-hover;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  & table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  & thead {
    background-color: @grey-hover;
  }
  & td, th {
    padding: 20px 24px;
  }
  & tbody tr, tfoot tr:not(:last-child) {
    border-bottom: 1px solid @grey-hover;
  }
  &__content {
    text-align: center;
  }
  &__col-group {
    width: 200px;
  }

  @media screen and (max-width: 670px) {
    .invoice-rd__col-group {
      width: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/tbooking-widget/SlotsTable.vue